import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

export const PROJECTED_METRICS_VALUES = {
    projected_cost: 'projected_cost',
    projected_revenue: 'projected_revenue',
    projected_conversions: 'projected_conversions',
    projected_clicks: 'projected_clicks',
};

export const DEFAULT_METRICS = {
    impressions: {
        label: 'Impressions',
        value: 'impressions',
        type: METRICS_TYPES.integer,
    },
    clicks: {
        label: 'Clicks',
        value: 'clicks',
        type: METRICS_TYPES.integer,
    },
    conversions: {
        label: 'Conversions',
        value: 'conversions',
        type: METRICS_TYPES.float,
    },
    revenue: {
        label: 'Conversions Value',
        value: 'revenue',
        type: METRICS_TYPES.currency,
    },
    cost: {
        label: 'Cost',
        value: 'cost',
        type: METRICS_TYPES.currency,
    },
    cost_per_conversion: {
        label: 'Cost per Conversion',
        value: 'cost_per_conversion',
        type: METRICS_TYPES.currency,
    },
    roas: {
        label: 'ROAS',
        value: 'roas',
        type: METRICS_TYPES.float,
    },
    cpc: {
        label: 'CPC',
        value: 'cpc',
        type: METRICS_TYPES.currency,
    },
    conv_value_conversion: {
        label: 'Conv Value / Conversion',
        value: 'conv_value_conversion',
        type: METRICS_TYPES.currency,
    },
    cost_conv_value: {
        label: 'Cost / Conv Value',
        value: 'cost_conv_value',
        type: METRICS_TYPES.currency,
    },
    conv_rate: {
        label: 'Conv Rate',
        value: 'conv_rate',
        type: METRICS_TYPES.currency,
    },
};

const {
    clicks,
    roas,
    cpc,
    cost,
    conversions,
    impressions,
} = DEFAULT_METRICS;

export const PROJECTION_METRICS = {
    projected_cost: {
        label: 'Projected Cost',
        value: PROJECTED_METRICS_VALUES.projected_cost,
        type: METRICS_TYPES.currency,
        isAdvancedMetric: true,
    },
    projected_revenue: {
        label: 'Projected Revenue',
        value: PROJECTED_METRICS_VALUES.projected_revenue,
        type: METRICS_TYPES.currency,
        isAdvancedMetric: true,
    },
    projected_conversions: {
        label: 'Projected Conversions',
        value: PROJECTED_METRICS_VALUES.projected_conversions,
        type: METRICS_TYPES.currency,
        isAdvancedMetric: true,
    },
    projected_clicks: {
        label: 'Projected Clicks',
        value: PROJECTED_METRICS_VALUES.projected_clicks,
        type: METRICS_TYPES.integer,
        isAdvancedMetric: true,
    },
};

const DEFAULT_ACCOUNT_METRICS = {
    clicks,
    cost,
    impressions,
    roas,
    cpc,
    conversions,
    ctr: {
        label: 'CTR',
        type: METRICS_TYPES.percent,
        value: 'ctr',
    },
    cpm: {
        label: 'CPM',
        type: METRICS_TYPES.currency,
        value: 'cpm',
    },
    cpa: {
        label: 'CPA',
        type: METRICS_TYPES.currency,
        value: 'cpa',
    },
    revenue: {
        label: 'Revenue',
        type: METRICS_TYPES.currency,
        value: 'revenue',
    },
    conv_rate: {
        label: 'Conv. Rate',
        type: METRICS_TYPES.percent,
        value: 'conv_rate',
    },
    ticket_value: {
        label: 'Ticket Value',
        type: METRICS_TYPES.currency,
        value: 'ticket_value',
    },
};

export const GOOGLE_ADS_CAMPAIGN_METRICS = {
    ...DEFAULT_ACCOUNT_METRICS,
    type: {
        label: 'Type',
        type: METRICS_TYPES.string,
        value: 'type',
    },
};

const FACEBOOK_ADS_CAMPAIGN_METRICS = {
    ...DEFAULT_ACCOUNT_METRICS,
};

export const CLIENT_METRICS = {
    ...GOOGLE_ADS_CAMPAIGN_METRICS,
    ...FACEBOOK_ADS_CAMPAIGN_METRICS,
};

export const ADVANCED_METRICS = {
    ...PROJECTION_METRICS,
};

export const METRICS_WITH_PROJECTION = {
    google_ads: {
        ...GOOGLE_ADS_CAMPAIGN_METRICS,
        ...ADVANCED_METRICS,
    },
    facebook_ads: {
        ...FACEBOOK_ADS_CAMPAIGN_METRICS,
        ...ADVANCED_METRICS,
    },
    client: {
        ...CLIENT_METRICS,
        ...ADVANCED_METRICS,
    },
};
